import { Search, Mic } from 'lucide-react';
import { motion, AnimatePresence } from 'framer-motion';
import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

const placeholders = [
  'هاتف Samsung Galaxy...',
  'أحذية رياضية Nike...',
  'ملابس نسائية...',
  'لابتوب HP ProBook...',
  'ساعة ذكية...',
  'عطور أصلية...',
  'أجهزة منزلية...',
  'إكسسوارات سيارات...',
];

const AnimatedSearchBar = () => {
  const navigate = useNavigate();
  const [currentIndex, setCurrentIndex] = useState(0);

  useEffect(() => {
    const timer = setInterval(() => {
      setCurrentIndex(i => (i + 1) % placeholders.length);
    }, 2800);
    return () => clearInterval(timer);
  }, []);

  return (
    <motion.div
      onClick={() => navigate('/search')}
      className="flex-1 flex items-center gap-2 h-10 px-3 rounded-xl bg-primary-foreground cursor-pointer shadow-sm hover:shadow-md transition-all duration-300 relative overflow-hidden"
      whileTap={{ scale: 0.98 }}
    >
      <Search size={15} className="text-muted-foreground flex-shrink-0" />
      <div className="flex-1 relative h-5 overflow-hidden">
        <AnimatePresence mode="wait">
          <motion.span
            key={currentIndex}
            initial={{ y: 14, opacity: 0 }}
            animate={{ y: 0, opacity: 0.4 }}
            exit={{ y: -14, opacity: 0 }}
            transition={{ duration: 0.3, ease: [0.25, 0.46, 0.45, 0.94] }}
            className="absolute inset-0 text-xs text-muted-foreground whitespace-nowrap leading-5 font-medium"
          >
            {placeholders[currentIndex]}
          </motion.span>
        </AnimatePresence>
      </div>
      <div className="w-7 h-7 rounded-lg bg-primary/10 flex items-center justify-center flex-shrink-0">
        <Mic size={12} className="text-primary" />
      </div>
    </motion.div>
  );
};

export default AnimatedSearchBar;
